import {useEffect} from 'react';
import {matchPath, NavLink, Outlet, useLocation} from 'react-router-dom';
import {Header} from '../../shared/components/Header';
import {Footer} from '../../shared/components/Footer';
import {HELP_CATEGORIES, HELP_HOME, HELP_PAGES} from './helpPages';

const SIGN_IN = '/sign-in';

// Content is ported verbatim from legacy help pages as plain HTML elements; style the tags here once.
const contentStyles = [
    '[&_h2]:text-2xl [&_h2]:font-medium [&_h2]:mt-10 [&_h2]:mb-3',
    '[&_h3]:text-lg [&_h3]:font-medium [&_h3]:mt-8 [&_h3]:mb-2',
    '[&_h4]:font-medium',
    '[&_p]:my-3',
    '[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_li]:my-1',
    '[&_a]:text-blue-60 [&_a]:underline',
    '[&_table]:w-full [&_table]:my-4 [&_table]:border-collapse',
    '[&_th]:border [&_th]:border-gray-30 [&_th]:bg-gray-10 [&_th]:p-2 [&_th]:font-medium',
    '[&_td]:border [&_td]:border-gray-30 [&_td]:p-2 [&_td]:align-top',
].join(' ');

const navLinkClass = ({isActive}: { isActive: boolean }) =>
    `block border-l-2 pl-3 py-1 ${isActive ? 'border-blue-60 font-medium text-gray-90' : 'border-transparent text-blue-60 hover:border-gray-30'}`;

export function HelpPageLayout() {
    const {pathname, hash} = useLocation();
    const page = HELP_PAGES.find(page => matchPath(page.path, pathname));
    const title = page?.title ?? page?.label ?? 'Help Center';

    useEffect(() => {
        if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    }, [pathname, hash]);

    return (
        <div className="min-h-screen bg-white flex flex-col">
            <Header logoLinkTo={SIGN_IN}/>
            <div className="flex-grow w-full max-w-6xl mx-auto px-8 py-12 flex flex-col md:flex-row gap-12 text-gray-90">
                <nav aria-label="Help Center" className="md:w-56 shrink-0">
                    <NavLink to={HELP_HOME} end className="block text-lg font-medium mb-3">Help Center</NavLink>
                    {HELP_CATEGORIES.map(category => (
                        <div key={category} className="mt-5">
                            <p className="text-sm font-medium text-gray-70 mb-2">{category}</p>
                            <ul>
                                {HELP_PAGES.filter(page => page.category === category).map(page => (
                                    <li key={page.path}><NavLink to={page.path} end className={navLinkClass}>{page.label}</NavLink></li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </nav>
                <main className="flex-1 min-w-0">
                    <h1 className="text-3xl font-medium mb-6">{title}</h1>
                    <div className={contentStyles}><Outlet/></div>
                </main>
            </div>
            <Footer/>
        </div>
    );
}
